/**
 * Get the google maps embeded URL from a tag or source
 * @param str Ifram with src or https link
 */

const DEFAULT_MAP_SRC =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4529.168578236509!2d-3.9858222626052595!3d5.3929619146450465!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfc193f6d9ffe851%3A0x8ddaeb28110ca4cc!2sDRO%20SARL!5e0!3m2!1sen!2sci!4v1664125310569!5m2!1sen!2sci'

export const getMapSrc = (str: string = DEFAULT_MAP_SRC) => {
  if (str.startsWith('https://www.google.com/maps/embed?')) return str

  if (str.startsWith('<iframe')) {
    const sections = str.split(' ')
    let found = false
    let i = 0

    while (!found && i < sections.length) {
      const section = sections[i]

      if (section.startsWith('src=')) {
        found = true

        // RETURNING URL
        return section.replace(/src=|"|'/gi, '')
      }

      i++
    }
  }

  return DEFAULT_MAP_SRC
}
